import React from 'react';
import { useThemeContext } from '../../../../../contexts/ThemeContext';
import { resolveColor } from '../../../theme/utils/resolveColor';
import * as S from './styles';

interface CheckboxFieldProps {
    id: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    accentColor?: string;
    children: React.ReactNode;
    decorate?: boolean;
    style?: React.CSSProperties;
}

export const CheckboxField = ({
    id,
    checked,
    onChange,
    accentColor,
    children,
    decorate = false,
    style = {},
}: CheckboxFieldProps) => {
    const { clientThemeSettings } = useThemeContext();
    const checkboxColor = resolveColor('primary', clientThemeSettings);

    return (
        <S.Row style={style}>
            <S.Input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                $accentColor={checkboxColor}
            />
            <S.Label htmlFor={id} $accentColor={accentColor} $decorate={decorate}>{children}</S.Label>
        </S.Row>
    );
};

export { S as CheckboxFieldStyles };
